import { render } from "./ModalExample.vue?vue&type=template&id=1441bf84&scoped=true"
import script from "./ModalExample.vue?vue&type=script&lang=js"
export * from "./ModalExample.vue?vue&type=script&lang=js"

import "./ModalExample.vue?vue&type=style&index=0&id=1441bf84&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1441bf84"

export default script